import { Box } from '@mui/material';
import { useState } from 'react';
import { ReactComponent as FallbackImageIcon } from '@src/assets/icons/avatar-fallback.svg';
interface Type {
  src: string | null;
  alt: string;
  size?: number;
}

function OrganisationImageFallback({ src, alt = '', size = 40 }: Type) {
  const [erorr, setError] = useState<boolean>(false);

  const showFallback = !src || erorr;

  return (
    <Box
      sx={{
        display: 'flex',
        width: size,
        height: size,
        borderRadius: 2,
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}>
      {showFallback ? (
        <FallbackImageIcon fontSize="small" />
      ) : (
        <img
          src={src}
          alt={alt}
          onError={() => {
            setError(true);
          }}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      )}
    </Box>
  );
}

export default OrganisationImageFallback;
